import { FormaPagamento, FormaPagamentoMap } from 'app/modulos/movimento/pagamento/pagamento';
import { Endereco, cepFormata, cepDigitos } from 'app/modulos/venda/entrega/endereco';
import { EstabelecimentoEndereco } from './estabelecimento';
import { FuncionamentoDia } from './estabelecimento-funcionamento';

// Cadastro da unidade feito pela loja: endereco, horario e pagamentos aceitos. O backend
// ainda nao tem onde guardar horario nem pagamentos, entao vive no storage por
// estabelecimento. Campo vazio significa "nao configurado" e mantem o comportamento antigo.
export class EstabelecimentoUnidade {
  endereco: Endereco;
  funcionamento: FuncionamentoDia[];
  pagamentos: FormaPagamento[];
}

export const FORMAS_PAGAMENTO = Array.from(FormaPagamentoMap, ([forma, nome]) => ({ forma, nome }));

// Nenhuma marcada vale como todas: sem isso, quem nunca abriu a tela ficaria sem
// nenhuma forma de pagar no checkout.
export function unidadePagamentos(unidade: EstabelecimentoUnidade): FormaPagamento[] {
  return unidade?.pagamentos?.length ? unidade.pagamentos : FORMAS_PAGAMENTO.map((opcao) => opcao.forma);
}

// O backend devolve o CEP com ponto e o numero como number; o formulario quer o formato
// do endereco do cliente.
export function unidadeEnderecoDeEstabelecimento(origem: EstabelecimentoEndereco): Endereco {
  const endereco = new Endereco();
  if (!origem) {
    return endereco;
  }
  endereco.apelido = origem.nome || '';
  endereco.cep = cepFormata(cepDigitos(origem.cep));
  endereco.logradouro = origem.logradouro || '';
  endereco.numero = origem.numero !== null && origem.numero !== undefined ? String(origem.numero) : '';
  endereco.complemento = origem.complemento || '';
  endereco.bairro = origem.bairro || '';
  endereco.cidade = origem.municipio?.nome || '';
  endereco.uf = origem.uf?.sigla || '';
  endereco.pontoReferencia = origem.referencia || '';
  return endereco;
}
